import { FDDialog } from '@facet-wealth/design';
import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import ModalForm2 from 'Views/Page/Content/Modal/Components/ModalForm2';
import { dataAttrs } from 'Helpers/Testing';


export const Dialog2 = ({
  Layout,
  metaOverrideSet,
  modalSize,
  fixedHeight = true,
  closeOnBackdropClick = false,
  color = undefined,
  forceNotFullScreen = false,
  noCloseButton,
}) => {
  const {
    modalCollection,
    clearModalCollection,
  } = useModalContext();
  const isMobile = useMobileLayout();
  let isFullScreen = isMobile;
  if (forceNotFullScreen) {
    isFullScreen = false;
  }

  return (
    <FDDialog
      {...dataAttrs('standard-dialog-root', modalCollection?.resources()?.head())}
      onClose={() => {
        clearModalCollection();
      }}
      dialogWidth={modalSize}
      fixedHeight={fixedHeight}
      fullScreen={isFullScreen}
      open={!!modalCollection}
      closeOnBackdropClick={closeOnBackdropClick}
      color={color}
      noCloseButton={noCloseButton}
    >
      <ModalForm2
        Layout={Layout}
        metaOverrideSet={metaOverrideSet}
      />
    </FDDialog>
  );
};
